module.exports = __webpack_public_path__ + "static/media/b6.37c7aa51.png";